export class ResultCode {
  public static readonly NO_ERROR: string = '';

  public static readonly TOO_MANY_LINES: string = 'TOO_MANY_LINES';

  public static readonly TOO_MANY_CHARACTERS_IN_LINE: string = 'TOO_MANY_CHARACTERS_IN_LINE';
  public static readonly TOO_MANY_LINES_FOR_CHARCOUNT: string = 'TOO_MANY_LINES_FOR_CHARCOUNT';
  public static readonly TOO_MANY_CHARACTERS_FOR_LINECOUNT: string = 'TOO_MANY_CHARACTERS_FOR_LINECOUNT';

  // No information could be retrieved to check entered text against (for given cell properties)
  public static readonly NO_VALID_CONFIG_FOUND: string = 'NO_VALID_CONFIG_FOUND';
  public static readonly NO_STRICT_VALID_CONFIG_FOUND: string = 'NO_STRICT_VALID_CONFIG_FOUND';
}
